import { render, staticRenderFns } from "./PatientContactForm.vue?vue&type=template&id=e2429e4c&"
import script from "./PatientContactForm.vue?vue&type=script&lang=js&"
export * from "./PatientContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports